module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATpJREFUWEftV6tOBDEUvaczHrE/gMdNZzICA5aHAgSO9SD4AuALEHwA6xDsKh4WDGLSaRV4fgCB7/aSbpZkAojOzGYTkl59z+npSXN7LqhDVVU1SNP0EMCehzPzxFp7U5blR1s6tAX4fq31ERFd/8AOpZSjtnxdBYyJaHb7Rk2klPtLEWCMeWLmjeZhAJ6zLNuMAqID0YHowP9zoK7rFWZeF0IcAFgNvcFfk7AF9t05dwvgBUqpcyHEWSh4kX3OuQsYY16ZeW2RxKFcAN68gF8fSyhB3z7/gUFrfUxEV33JOuJPME83u0S0A2AQStTzEfrkdG+tvesUSGIeiA5EB6ID0QGttd8L/X7YrJGUchg6yr/7Oo1ipdSWEOKheZhzbrsoiselCJinqNMkSWbL6HQ6HQO4zPP8s62AL3WqCiwz3wkIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.png
// module id = Zarb
// module chunks = 1